import { RSAA } from 'redux-api-middleware';
import { getGeolocation } from '../../utils/helper/page-behavior-helper';
import { getCoordinateAxleFromStorage, getRequestAdditionalHeader } from './util-actions';

export const BUSINESS_LOG = '/log/business';
export const BUSINESS_LOG_SUCCESS = '/log/business/success';
export const BUSINESS_LOG_FAILURE = '/log/business/failure';

export const INTEGRATION_LOG = '/log/integration';
export const INTEGRATION_LOG_SUCCESS = '/log/integration/success';
export const INTEGRATION_LOG_FAILURE = '/log/integration/failure';

/**
 * Logs a business event.
 */
export function logBusiness(code, duration, input, output, error, device, productItemId) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/log/business`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({
        code,
        device,
        productItemId,
        execution: {
          duration,
          input: input ? (input.constructor === Array ? input : [input]) : null,
          output,
          error,
        },
      }),
      types: [BUSINESS_LOG, BUSINESS_LOG_SUCCESS, BUSINESS_LOG_FAILURE],
    },
  };
}

/**
 * Logs an integration event.
 */
export function logIntegration(code, duration, input, output, error, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/log/integration`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({
        code,
        device,
        execution: {
          duration,
          input: input ? (input.constructor === Array ? input : [input]) : null,
          output,
          error,
        },
      }),
      types: [INTEGRATION_LOG, INTEGRATION_LOG_SUCCESS, INTEGRATION_LOG_FAILURE],
    },
  };
}
